import { Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import Emeriti from "./pages/Emeriti";
import Retirements from "./pages/Retirements";
import AlumniHighlights from "./pages/AlumniHighlights";
import StudentHighlights from "./pages/StudentHighlights";
import FacultyHighlights from "./pages/FacultyHighlights";

import logoBrand from "./images/logo/byu-school-of-accountancy-logo.png";
import logoSOA from "./images/logo/logo-soa.png";
import logoAnnualReport from "./images/logo/annual-report-25.png";

import ReactGA from "react-ga4";
// import MiddleY from "./components/MiddleY";

ReactGA.initialize("G-591437YLLN");
ReactGA.send({ hitType: "pageview", page: "/", title: "Home | BYU SOA 2025" });
ReactGA.send({ hitType: "pageview", page: "/faculty-and-students", title: "Faculty and Students | BYU SOA 2025" });
ReactGA.send({ hitType: "pageview", page: "/emeriti", title: "Emeriti | BYU SOA 2025" });
ReactGA.send({ hitType: "pageview", page: "/retirements", title: "Retirements | BYU SOA 2025" });
ReactGA.send({ hitType: "pageview", page: "/alumni-highlights", title: "Alumni | BYU SOA 2025" });
ReactGA.send({ hitType: "pageview", page: "/student-highlights", title: "Student Highlights | BYU SOA 2025" });
ReactGA.send({ hitType: "pageview", page: "/faculty-highlights", title: "Faculty Highlights | BYU SOA 2025" });
ReactGA.send({
  hitType: "pageview",
  page: "/faculty-published-textbooks",
  title: "Faculty Published Textbooks | BYU SOA 2025",
});

function App() {
  return (
    <>
      <div className="logo-brand">
        <img src={logoBrand} alt="BYU Marriott Logo" />
      </div>
      <div className=" logo-soa">
        <img src={logoSOA} alt="BYU SOA Logo" />
      </div>
      <div className="logo-annual-report">
        <img src={logoAnnualReport} alt="BYU Annual Report Logo" />
      </div>

      <div className="btn-archive">
        <a href="/24">Annual Report 2024</a>
      </div>

      <div className="main-bg">
        <Routes>
          <Route index element={<HomePage />} />
          <Route path="/faculty-and-students" element={<HomePage />} />
          <Route path="/faculty-published-textbooks" element={<HomePage />} />
          <Route path="/emeriti" element={<Emeriti />} />
          <Route path="/retirements" element={<Retirements />} />
          <Route path="/alumni-highlights" element={<AlumniHighlights />} />
          <Route path="/student-highlights" element={<StudentHighlights />} />
          <Route path="/faculty-highlights" element={<FacultyHighlights />} />

          <Route path="*" element={<HomePage />} />
        </Routes>
      </div>
    </>
  );
}

export default App;
